/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
	selector: 'loading-blocker-success',
	templateUrl: './loading-blocker-success.component.html',
	styleUrls: ['../loading-blocker.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingBlockerSuccessComponent {
	@Input() displayGlobally: boolean = false;

	constructor() {}
}
